import Collapsible from '@/components/modules/Collapsible';

interface WithdrawAssetsCollapseProps {
  enabled: boolean;
  assets: React.ReactNode;
  selectedCount: number;
}

export const WithdrawAssetsCollapse = ({
  enabled,
  assets,
  selectedCount,
}: WithdrawAssetsCollapseProps) => {
  return (
    <>
      {enabled && (
        <Collapsible header={<h2>Redeem NFTs ({selectedCount})</h2>} open>
          {!!assets && assets}
        </Collapsible>
      )}
    </>
  );
};
